module.exports = __webpack_public_path__ + "media/images/BlockS_white_transparent-3fbf09475ba407002c90574b9d205eff.svg";